export class PromiseCancelledError extends Error {
    constructor(message?: string) {
        super(message);
        // Need to do this when extending error because of some typescript weirdness
        // https://stackoverflow.com/questions/41102060/typescript-extending-error-class
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
